import React, { useEffect, useMemo } from 'react';
import taskService from 'services/http/task-service';
import utils from 'utils';
import { SkeletonLoader, WithLoadingComponent } from 'components/shared';

export const TaskActivity = (props) => {

    const { data: events } = props;

    useEffect(() => {
        utils.fixContainersOverlaping(".activity-content");
    }, []);

    //EVENT ITEM TEMPLATE
    const ChronologyItem = (props) => {
        let item = props.event;
        return (
            <li>
                <span className="font-italic" style={{ color: "#22c0e8" }}>{item.stepId}</span>
                <small className="float-right">Async delay {item.delay / 60} min</small><br />
                <small>{item.description}</small>
                <div>
                    <small className="font-weight-bold">Action date {new Date(item.creationDate).toLocaleString()}</small>&nbsp;
                    {item.username && <small>by {item.username.toUpperCase()}</small>}
                </div>
            </li>
        );
    }

    return (
        <div className={`${props.taskView && 'scroll-container activity-content'}`}>
            <ul className="timeline">
                {
                    events && events.map((item) => {
                        return (
                            <ChronologyItem event={item} />
                        );
                    })
                }
            </ul>
        </div>
    );
}

export const TaskActivityHoc = (props) => {
    const { task } = props;
    const ActivityHoc = useMemo(() => WithLoadingComponent(TaskActivity, () => taskService.getChronology(task.interventionId), <SkeletonLoader factor={4} />)(props), [task.interventionId, task.step.stepId]);
    return <ActivityHoc />
}